import React, { useContext, useState } from 'react';
import { AccountContext } from '../../AccountContext';
import { useMerchantGatewayService } from '@app/sdk';

export default function MatchedRefundTransaction(props) {
  const { accountId, transactionService, setError } = useContext(AccountContext);
  const { transactionId, description, initialAmount, initialUpfrontPaymentAmount } = props;
  const [amount, setAmount] = useState(String(initialAmount));
  const [upfrontPaymentRefundAmount, setUpfrontPaymentRefundAmount] = useState('');
  const [refunding, setRefunding] = useState(false as boolean);
  const merchantGatewayService = useMerchantGatewayService();
  const refundAmount = amount === '' ? undefined : Number(amount);
  const upfrontRefundAmount = initialUpfrontPaymentAmount == null || upfrontPaymentRefundAmount === ''
    ? undefined : Number(upfrontPaymentRefundAmount);
  const validRefundAmount = refundAmount === undefined ||
    (Number.isFinite(refundAmount) && refundAmount > 0 && refundAmount <= initialAmount);
  const validUpfrontRefundAmount = upfrontRefundAmount === undefined ||
    (Number.isFinite(upfrontRefundAmount) && upfrontRefundAmount >= 0 && upfrontRefundAmount <= initialUpfrontPaymentAmount);
  const canRefund = validRefundAmount && validUpfrontRefundAmount &&
    (refundAmount !== undefined || upfrontRefundAmount !== undefined);

  const onRefundClicked = async () => {
    if (refunding || !canRefund) return;

    try {
      setRefunding(true);
      if (refundAmount === undefined) {
        await transactionService.refundUpfrontPayment(
          accountId,
          transactionId,
          { value: upfrontRefundAmount, currencyCode: 'GBP' }
        );
      } else if (initialUpfrontPaymentAmount != null) {
        await transactionService.refund(
          accountId,
          transactionId,
          { value: refundAmount, currencyCode: 'GBP' },
          `${description} refund`,
          upfrontRefundAmount === undefined ? undefined : { value: upfrontRefundAmount, currencyCode: 'GBP' }
        );
      } else {
        await merchantGatewayService.refund(accountId, refundAmount, `${description} refund`, transactionId);
      }
      setRefunding(false);
    } catch (error) {
      setRefunding(false);
      setError({ source: 'Refund', ...error });
    }
  };

  return (
    <div className="field fill">
      <div className="ui labeled input">
        <div className="ui label">£</div>
        <input
          name="amount"
          type="number"
          step=".01"
          min=".01"
          max={initialAmount}
          value={amount}
          onChange={(event) => setAmount(event.target.value)}
          disabled={refunding}
        />
        {initialUpfrontPaymentAmount != null && (
          <>
            <div className="ui label">Upfront £</div>
            <input
              name="upfrontPaymentRefundAmount"
              aria-label="Upfront payment refund amount (optional)"
              type="number"
              step=".01"
              min="0"
              max={initialUpfrontPaymentAmount}
              placeholder="Optional"
              value={upfrontPaymentRefundAmount}
              onChange={(event) => setUpfrontPaymentRefundAmount(event.target.value)}
              disabled={refunding}
            />
          </>
        )}
        <button
          className={`ui right floated button ${refunding ? 'loading' : ''}`}
          disabled={refunding || !canRefund}
          onClick={onRefundClicked}>
          Refund
        </button>
      </div>
    </div>
  );
}
